import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
// import {msjLine} from "../../layouts/components/InfoOnline";
import {MunicipalityInterface} from "../interface/query/debs/municipality-interface";
import {AntInterface} from "../interface/query/debs/ant-interface";

export const findDebtsAnt = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/debts/traffic_fine/ant`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp: AntInterface[] = interceptorResponse(response.data.object)
            if (resp === null || (resp && resp.length === 0)) {
                // msjLine(data.msj)
            }
            return resp
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/debts/traffic_fine/ant', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /debts/traffic_fine/ant`);
    })
}

export const useFindDebtsAnt = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findDebtsAnt(data),
    });
}

export const findDebtsMunicipality = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/debts/municipality`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp: MunicipalityInterface[] = interceptorResponse(response.data.object)
            if (resp === null || (resp && resp.length === 0)) {
                // msjLine(data.msj)
            }
            return resp
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/debts/municipality', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /debts/municipality`);
    })
}

export const useFindDebtsMunicipality = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findDebtsMunicipality(data),
    });
}
